import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ApiService {
  private baseUrl: string;
  submitProfileURl = 'enterprise/submit-profile';
  
  constructor(private http: HttpClient, @Optional() @Inject('BASE_API_URL') baseUrl?: string) {
    this.baseUrl = baseUrl ? baseUrl + '' : '';
  }
  /** change Assessment Status */
  submitProfile(obj) {
    const url = `${this.baseUrl}enterprise/submit-profile`;
    return this.http.post(url, obj).pipe(
      tap(),
      catchError(this.handleError<any>('submit Profile Fail'))
    );
  }

  sendEmail(data: any): Observable<any> {
    const url = 'https://formspree.io/f/xwkalgvv';
    return this.http.post(url, data);
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return throwError(error);
    };
  }

}
